export function roundToTwoDecimals (value: number): number {
    return Math.round(100 * value) / 100.0;
}